// Unique Value Proposition Component

import React from "react"
// import { ConnectWithUsBtns } from "../home/LandingSection"
import "./uniqueValuePropositions.scss"
import { PortableText } from "@portabletext/react"
import { Link } from "gatsby"
import { motion } from "framer-motion"

function UniquevaluePropositions({ data }) {
  const srelizerComponent = {
    marks: {
      link: ({ children, value }) => {
        const { blank, href } = value
        return blank ? (
          <a
            title={href}
            href={href}
            target="_blank"
            rel="noopener"
            // style={{ textDecoration: "underline" }}
          >
            {children}
          </a>
        ) : (
          <a href={href} title={href}>
            {children}
          </a>
        )
      },
      color: ({ children, value }) => {
        return <span style={{ color: value.color }}>{children}</span>
      },
    },
  }

  // const [showBothButtons, setShowBothButtons] = useState<boolean>(false)

  return (
    <div
      className="section homepage homepage-our-unique-value-container"
      id="our-unique-value-container"
    >
      {data?.backgroundImage && (
        <img
          src={data?.backgroundImage?.asset?.url}
          //   style={{ x: transform }}
          alt="background image"
          className="background-image"
        />
      )}
      <motion.div
        whileInView={{ opacity: 1, y: 0 }}
        // viewport={{ once: true }}
        initial={false}
        animate={{ opacity: 0, y: 20 }}
        transition={{ type: "linear", delay: 0.15 }}
        className="section-header-wrapper"
      >
        {data?._rawNewSlideTitle ? (
          <>
            <PortableText
              value={data?._rawNewSlideTitle}
              components={srelizerComponent as any}
            />
            {data?._rawSubtitle && (
              <PortableText
                value={data?._rawSubtitle}
                components={srelizerComponent as any}
              />
            )}
          </>
        ) : (
          <>
            <h2 className="homepage-section-title">{data?.slide_title}</h2>
            {data?.slide_subtitle && (
              <h3 className="homepage-section-sub-title">
                {data?.slide_subtitle}
              </h3>
            )}
          </>
        )}
        {/* <ConnectWithUsBtns
          // initialTitle={"Let's Connect"}
          showBothButtons={showBothButtons}
          setShowBothButtons={setShowBothButtons}
        /> */}
        {data?.cta?.length > 0 && (
          <div className="new-buttons-wrapper">
            {data?.cta?.map((button: any, index: number) => (
              <div className="new-button-container" key={index}>
                <Link to={button?.cta_link}>
                  <button className={`${button?.cta_style}`}>
                    {button?.cta_name}
                  </button>
                </Link>
              </div>
            ))}
          </div>
        )}
      </motion.div>
      <div className="unique-values-proposition-cards">
        {/* remove this map once gov and homepage is shifted to new-slide sanity */}
        {data?.uniqueValues &&
          data?.uniqueValues?.map((value: any, index: number) => (
            <motion.div
              whileInView={{ opacity: 1, y: 0 }}
              // viewport={{ once: true }}
              initial={false}
              animate={{ opacity: 0, y: "10%" }}
              transition={{
                type: "spring",
                delay: 0.1 * index + 0.05,
                bounce: 0.2,
              }}
              viewport={{ amount: 0.5 }}
              className={`unique-value-card ${
                value?.isHomepageDesign ? "image-value-card" : "icon-value-card"
              }`}
              key={index}
            >
              <div
                className={`${
                  value?.isHomepageDesign
                    ? "value-image-wrapper"
                    : "icon-value-wrapper"
                }`}
              >
                {value?.isHomepageDesign ? (
                  <img
                    src={value?.image?.asset?.url}
                    alt={value?.title}
                    loading="lazy"
                  />
                ) : (
                  <img
                    src={value?.valueIcon?.asset?.url}
                    alt={value?.title}
                    loading="lazy"
                  />
                )}
              </div>
              <h3 className="unique-value-title">{value?.title}</h3>
              <p className="value-description">{value?.valueDescription}</p>
            </motion.div>
          ))}

        {/* new slide section */}
        {data?.cards &&
          data?.cards?.map((value: any, index: number) => (
            <motion.div
              whileInView={{ opacity: 1, y: 0 }}
              initial={false}
              animate={{ opacity: 0, y: "10%" }}
              transition={{
                type: "spring",
                delay: 0.1 * index + 0.05,
                bounce: 0.2,
              }}
              viewport={{ amount: 0.5 }}
              className={`unique-value-card image-value-card`}
              key={index}
            >
              <div className={`value-image-wrapper`}>
                <img
                  src={value?.cardImage?.asset?.url}
                  alt={value?.imageAlt ? value?.imageAlt : value?.cardName}
                  loading="lazy"
                />
              </div>
              <div className="unique-value-title">
                <PortableText
                  value={value?._rawTitle}
                  components={srelizerComponent as any}
                />
              </div>
              <div className="value-description">
                <PortableText
                  value={value?._rawDescription}
                  components={srelizerComponent as any}
                />
              </div>
            </motion.div>
          ))}
      </div>

      {/* connect buttons */}
      {data?.content_footer && (
        <motion.div
          whileInView={{ opacity: 1, y: 0 }}
          // viewport={{ once: true }}
          initial={false}
          animate={{ opacity: 0, y: 20 }}
          transition={{ type: "linear", delay: 0.1 }}
          className="footer-text-wrapper"
        >
          <p className="footer-text">{data?.content_footer}</p>
        </motion.div>
      )}

      {data?._rawFooterText && (
        <motion.div
          whileInView={{ opacity: 1, y: 0 }}
          // viewport={{ once: true }}
          initial={false}
          animate={{ opacity: 0, y: 20 }}
          transition={{ type: "linear", delay: 0.1 }}
          className="footer-text-wrapper"
        >
          <PortableText
            value={data?._rawFooterText}
            components={srelizerComponent as any}
          />
        </motion.div>
      )}
    </div>
  )
}

export default UniquevaluePropositions
